import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import PubSub from "pubsub";
import io from "socket.io-client";

"use strict";
var subscriptions = {
    "waitfor":[],
    "subscribe":[],
    "subscribe_relation":[],
    "epics": []
};

function resubscribe() {
    uly.socket.emit("register", ko.unwrap((uly.page.userprofile || {}).id) );
    subscriptions.waitfor.forEach(function(v) {
        uly.socket.emit("waitfor", v);
    });
    subscriptions.subscribe.forEach(function(v) {
        uly.socket.emit("subscribe", v);
    });
    subscriptions.subscribe_relation.forEach(function(v) {
        uly.socket.emit("subscribe_relation", v);
    });
    subscriptions.epics.forEach(function(v) {
        uly.socket.emit("epic_start", v);
    });
}

$.extend(uly, {
    publish: function(topic, message, sync) {
        if (sync !== true) {
            PubSub.publish(topic.toLowerCase(), message);
        } else {
            PubSub.publishSync(topic.toLowerCase(), message);
        }
    },
    subscribe: function(topic, callback, dom_node) {
        var token = PubSub.subscribe(topic.toLowerCase(), callback);
        //allow auto-unsubscription when dom_node is destroyed
        if (dom_node) {
            if (dom_node instanceof $) {
                dom_node = dom_node[0];
            }
            ko.utils.domNodeDisposal.addDisposeCallback(dom_node, function() {
                PubSub.unsubscribe(token);
                token = null;
            });
        }

        return { "id":token, "unsubscribe":function() {
            PubSub.unsubscribe(token);
        } };
    },
    unsubscribe: function(token_or_callback){
        return PubSub.unsubscribe(token_or_callback);
    },
    setup_web_socket: function setup_web_socket(url) {
        uly.page.userprofile.id.subscribe((newvalue) => {
            if (uly.socket) {
                uly.socket.emit("register", ko.unwrap(uly.page.userprofile.id()));
            }
        });
    
        //don't recreate a socket to the same place as now.
        if (uly.current_socket_url && uly.socket && uly.current_socket_url == url)
            return;

        var socket = io.connect(url);
        socket.on("waitchanged", function(entity, unique_id) {
            if (typeof unique_id === "undefined") {
                unique_id = entity[1];
            }
            uly.publish("socket.wait.changed."+unique_id, unique_id);
        });
        socket.on("subchanged", function(entity, unique_id) {
            if (typeof unique_id === "undefined") {
                unique_id = entity[1];
            }
            uly.publish("socket.subscription.changed." + unique_id.toLowerCase(), unique_id);
        });
        socket.on("relationchanged", function(unique_id, relation) {
            if (typeof relation === "undefined") {
                relation = unique_id[1];
                unique_id = unique_id[0];
            }
            uly.publish("socket.subscription.relchanged."+relation, unique_id, relation);
        });
        socket.on("serverevent", function(event_key, status, message) {
            if (typeof message === "undefined") {
                message = event_key[2];
                status = event_key[1];
                event_key = event_key[0];
            }
            uly.publish("socket.server.event." + event_key, {"status":status, "message":message });
        });
        socket.on("servereventsubscribed", function(event_key) {
            uly.publish("socket.server.event_sub." + event_key, {});
        });
        socket.on("epicprogress", function(epic_id, progress, finished, description, success) {
            if (typeof progress === "undefined") {
                success = epic_id[4];
                description = epic_id[3];
                finished = epic_id[2];
                progress = epic_id[1];
                epic_id = epic_id[0];
            }
            uly.publish("socket.epic.progress."+ epic_id, {"progress": progress, "finished": finished, "description": description, "success": success});
        });
        socket.on("promptuser", function(question_id, question, title, yes_caption, no_caption) {
            if (typeof question === "undefined") {
                no_caption = question_id[4];
                yes_caption = question_id[3];
                title = question_id[2];
                question = question_id[1];
                question_id = question_id[0];
            }
            uly.dialogs.ask_user(title, question, yes_caption, no_caption).then(
                () => {
                    socket.emit("userresponse", question_id, "yes");
                },
                () => {
                    socket.emit("userresponse", question_id, "no");
                }
            )
        });
        
        socket.on("reconnect", function() {
            resubscribe();
        });
        socket.on("connect", function() { 
            uly.socket.emit("register", ko.unwrap((uly.page.userprofile || {}).id));
        });

        if (uly.socket) {
            try {
                var old_socket = uly.socket;
                uly.socket = null;
                old_socket.disconnect();
            }
            catch(e) {
                console.error("Error disconnecting previous socket:", old_socket, e);
            }
        }
        uly.socket = socket;
        uly.current_socket_url = url;
    },
    waitFor: function(entity_id, elt) {
        var def = Promise.Deferred();
        var sub_callback = function (entity_id) {
            def.resolve(entity_id);
        };
        var token = uly.subscribe("socket.wait.changed."+entity_id, sub_callback, $(elt)[0]);
        def.always(function() { uly.unsubscribe(token); });
        if (!uly.socket) {
            console.error("No web socket present. refresh will fail...");
            //setTimeout(function() { console.error("no socket: fake timeout:", entity_id); uly.publish("socket.wait.changed."+entity_id, entity_id); }, 500);
        }
        else {
            subscriptions["waitfor"].push(entity_id);
            uly.socket.emit("waitfor", entity_id);
        }
        return def;
    },
    subscribeToEpic: function(epic_id, callback, elt) {
        if (!epic_id) {
            return null;
        }
        var subscription  = uly.subscribe("socket.epic.progress."+epic_id.toLowerCase(), callback, elt);
        if (uly.socket) {
            subscriptions["epics"].push(epic_id.toLowerCase());
            uly.socket.emit("epic_start", epic_id.toLowerCase());
        }
        return subscription;
    },
    unsubscribeToEpic: function(epic_id, token_or_callback) {
        if (uly.socket) {
            if (epic_id) {
                subscriptions["epics"].splice(subscriptions["epics"].indexOf(epic_id.toLowerCase()),1);
                uly.socket.emit("epic_unsubscribe", epic_id.toLowerCase());
            }
        }
        if (token_or_callback.unsubscribe)
            return token_or_callback.unsubscribe();
        return uly.unsubscribe(token_or_callback);
    },
    subscribeToChange: function(entity_id, callback, elt) {
        if (!entity_id) {
            return null;
        }
        var subscription  = uly.subscribe("socket.subscription.changed."+entity_id.toLowerCase(), callback, elt);
        if (uly.socket) {
            subscriptions["subscribe"].push(entity_id.toLowerCase());
            uly.socket.emit("subscribe", entity_id.toLowerCase());
        }
        return subscription;
    },
    unsubscribeToChange: function(entity_id, token_or_callback) {
        if (uly.socket) {
            if (entity_id) {
                subscriptions["subscribe"].splice(subscriptions["subscribe"].indexOf(entity_id.toLowerCase()),1);
                uly.socket.emit("unsubscribe", entity_id.toLowerCase());
            }
        }
        if (token_or_callback.unsubscribe)
            return token_or_callback.unsubscribe();
        return uly.unsubscribe(token_or_callback);
    },
    subscribeToRelatedChange: function(entity_rel, callback, elt) {
        var subscription  = uly.subscribe("socket.subscription.relchanged."+entity_rel, callback, elt);
        if (uly.socket) {
            subscriptions["subscribe_relation"].push(entity_rel);
            uly.socket.emit("subscribe_relation", entity_rel);
        }
        return subscription;
    },
    unsubscribeToRelatedChange: function(entity_rel, token_or_callback) {
        if (uly.socket) {
            subscriptions["subscribe_relation"].splice(subscriptions["subscribe_relation"].indexOf(entity_rel),1);
            uly.socket.emit("unsubscribe_relation", entity_rel);
        }
        if (token_or_callback.unsubscribe)
            return token_or_callback.unsubscribe();
        return uly.unsubscribe(token_or_callback);
    },
    bulkSubscribeToChange: function(new_ids, previous_data, callback, elt) {
        if (typeof previous_data == "function" && typeof elt == "undefined") {
            elt = callback;
            callback = previous_data;
            previous_data = null;
        }

        if (!previous_data) {
            previous_data = {
                "ids":[],
                "tokens":[],
                "dispose":function() {
                    for (var i=0;i<this.ids.length;++i){
                        uly.unsubscribeToChange(this.ids[i], this.tokens[i]);
                    }
                    this.ids = [];
                    this.tokens  = [];
                    this.disposed = true;
                }
            };
            if (elt) {
                if (elt instanceof $)
                    elt = elt[0];
                ko.utils.domNodeDisposal.addDisposeCallback(elt, function() {
                    previous_data.dispose();
                });
            }
        }
        else if (previous_data.disposed) throw _("pubsub_trying_to_reuse_a_disposed_bulk_subscription", "Trying to reuse a disposed bulk subscription");

        var notyet = [];
        var already = [];
        var toremove = [];
        for (var i=0;i<new_ids.length;++i) {
            id = new_ids[i];
            if (previous_data.ids.indexOf(id)<0) {
                notyet.push(id);
            }
            else {
                already.push(id);
            }
        }

        for (var i=0;i<previous_data.ids.length;++i) {
            var id = previous_data.ids[i];
            var found = false;
            for (var j=0;j<already.length;++j) {
                if (id == already[j]) {
                    found =true;
                    break;
                }
            }
            if (!found) {
                toremove.push({"id":id, "idx":i });
            }
        }
        for (var i=toremove.length - 1; i>=0; --i) {
            uly.unsubscribeToChange(toremove[i].id, previous_data.tokens[toremove[i].idx] );
            previous_data.tokens.splice(toremove[i].idx,1);
            previous_data.ids.splice(toremove[i].idx,1);
        }
        for (var i = 0;i<notyet.length;++i) {
            var token = uly.subscribeToChange(notyet[i], callback, elt);
            previous_data.ids.push(notyet[i]);
            previous_data.tokens.push(token);
        }
        return previous_data;
    },
    subscribeToEvent: function(event_key, callback, elt) {
        var res = Promise.Deferred();
        res.subscription =  uly.subscribe("socket.server.event."+event_key, callback, elt);
        var ssub = uly.subscribe("socket.server.event_sub."+event_key, function() {
            res.resolve(res.subscription);
            uly.unsubscribe(ssub);
        });
        if (uly.socket)
            uly.socket.emit("event_subscribe", event_key);
        return res;
    },
    unsubscribeToEvent: function(event_key, token_or_callback) {
        if (uly.socket)
            uly.socket.emit("event_unsubscribe", event_key);
        if (token_or_callback.unsubscribe)
            return token_or_callback.unsubscribe();
        return uly.unsubscribe(token_or_callback);
    }
});
